import * as React from "react";
import PropTypes from "prop-types";
import { IconPencil } from "./Icons";
import Tappable from "./Tappable";
import prefixStyles from "./utils/prefixStyles";

const styles = prefixStyles({
  container: {
    display: "flex",
    alignItems: "center",
  },
  input: {
    fontSize: "1em",
    width: "100%",
    maxWidth: "20em",
  },
  icon: {
    position: "absolute",
    right: 0,
  },
});

export default class EditableText extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    disabled: PropTypes.bool,
    inputSize: PropTypes.number,
    maxWidth: PropTypes.number,
    maxTextLength: PropTypes.number,
    onChange: PropTypes.func,
    onEditStart: PropTypes.func,
    onEditEnd: PropTypes.func,
  };

  static defaultProps = {
    inputSize: 16,
    maxWidth: 200,
    maxTextLength: 32,
  };

  state = {
    isEditing: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const { isEditing } = this.state;
    if (isEditing && !prevState.isEditing && this._input) {
      this._input.focus();
      this._input.setSelectionRange(0, (this._input.value || "").length);
    }
  }

  _toggleEditing = () => {
    this.setState(
      (prevState) => ({ isEditing: !prevState.isEditing }),
      () => {
        const callback = this.state.isEditing
          ? this.props.onEditStart
          : this.props.onEditEnd;

        if (callback) {
          callback();
        }
      }
    );
  };

  _handleKeyPress = (ev) => {
    if (ev.charCode === 13) {
      this._toggleEditing();
    }
  };

  // Hack for Android not honoring maxLength
  _handleInput = (ev) => {
    if (ev.target.value.length > this.props.maxTextLength) {
      ev.target.value = ev.target.value.slice(0, this.props.maxTextLength);
    }
  };

  _handleChange = (ev) => {
    if (!this.props.onChange) {
      return;
    }
    this.props.onChange(ev.target.value);
  };

  render() {
    const { value, disabled, inputSize, maxWidth, maxTextLength } = this.props;

    const { isEditing } = this.state;

    const labelStyle = {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      minWidth: 24,
      maxWidth,
      position: "relative",
      padding: 4,
      paddingRight: "1.2em",
      outline: "none",
    };

    const pencilIcon = !disabled && <IconPencil style={styles.icon} />;

    return (
      <span style={styles.container} data-component-name="EditableText">
        {isEditing && !disabled ? (
          <input
            style={styles.input}
            type="text"
            size={inputSize}
            value={value}
            maxLength={maxTextLength}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            onKeyPress={this._handleKeyPress}
            onChange={this._handleChange}
            onInput={this._handleInput}
            onBlur={this._toggleEditing}
            ref={(el) => (this._input = el)}
          />
        ) : (
          <Tappable onTap={this._toggleEditing}>
            {({ tapTargetRefHandler }) => (
              <span
                data-component-section="tap-to-edit"
                ref={tapTargetRefHandler}
                style={labelStyle}
                tabIndex="0"
              >
                {value}
                {pencilIcon}
              </span>
            )}
          </Tappable>
        )}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/EditableText.jsx